<template>
  <div id="app">
    <router-view></router-view>
    <app-footer></app-footer>
  </div>
</template>

<script>
import appFooter from './pages/Login/app-footer'
// import config from './portal-config.json'

export default {
  name: 'app',
  async created () {
    const vm = this
    await vm.loadConfigFile()
  },
  components: {
    appFooter
  },
  methods: {
    async loadConfigFile () {
      const vm = this
      await vm.$http.get(`${location.protocol}//${location.host}/portal-config.json`).then(config => {
        vm.config = config.data[0].client
      }, err => {
        console.log(err)
      })
    }
  },
  data () {
    return {
      config: {
        logo_url: '',
        footer_text: '',
        clinic_info: {}
      }
    }
  }
}
</script>

<style lang="sass">

// Custom variables and variables overwrites

@import "./assets/theme.sass"

// Default variables and mixins
@import "./../node_modules/uikit/src/scss/variables-theme.scss"
@import "./../node_modules/uikit/src/scss/mixins-theme.scss"

// Custom mixin overwrites

// UI library

@import "./../node_modules/uikit/src/scss/uikit-theme.scss"
@import "./../node_modules/uikit/src/scss/uikit.scss"

body *
  -webkit-font-smoothing: antialiased
  -moz-osx-font-smoothing: grayscale
  text-rendering: optimizeLegibility

html, body, #app
  height: 100%
  width: 100%

</style>

<style>
  ::-webkit-scrollbar {
      width: 10px;
  }

  /* Track */
  ::-webkit-scrollbar-track {
      background: #f1f1f1; 
  }
  
  /* Handle */
  ::-webkit-scrollbar-thumb {
      background: #888; 
  }

  /* Handle on hover */
  ::-webkit-scrollbar-thumb:hover {
      background: #555; 
  }
</style>



// WEBPACK FOOTER //
// App.vue?6c237ace